<div class="cards-by-qr-rating-container px-3 gap-5 h-100 pb-200px">
  <main class="card-by-qr-rating-container-content d-flex flex-column gap-3 position-relative pb-5">
    <!-- HEADER -->
    <div class="d-flex flex-row align-items-center gap-2 cards-by-qr-header py-4">
      <mat-icon class="d-flex align-items-center justify-content-center cursor-pointer"
                (click)="backToCardReviews()">
        arrow_back
      </mat-icon>
      <span>{{'rating.all_reviews' | translate}}</span>
    </div>

    <!-- USER CARD INFORMATION -->
    <div class="d-flex flex-row align-items-center gap-5">
      <!-- PICTURES -->
      <div class="position-relative">
        <img
          [src]="userCardProfilePicture || 'assets/svg/defaultUserIcon.svg'"
          alt="Profile picture"
          class="profile-picture"
          (error)="userCardProfilePicture = 'assets/svg/defaultUserIcon.svg'"/>
        @if (dataFromReviewsPage.companyLogoExists) {
                          <img [src]="dataFromReviewsPage.companyLogo" [alt]="'user_card.company_logo' | translate" class="company-logo">
        }
      </div>

      <!-- INFO -->
      <div class="d-flex flex-column ">
        <span class="full-name">{{ dataFromReviewsPage.userCardFullName }}</span>
        <span class="company-information">{{ dataFromReviewsPage.userCardSpecialization }}</span>
      </div>
    </div>

    <hr>

    <!-- REVIEW FORM -->
    <form [formGroup]="manageForm">
      <div class="d-flex flex-column gap-2 py-2">
        <div class="d-flex align-items-center w-100 justify-content-center">
          <app-rating [rating]="rating" [starSize]="48" [isEditable]="true"
                      (ratingChange)="setRating($event)"></app-rating>
        </div>

        <div class="d-flex flex-row align-items-start gap-3 mt-5 pb-2">
          <img [src]="currentUserProfilePicture" alt="Profile picture"
               class="reviewer-profile-picture"
               (error)="onProfileImageError()">
          <div class="d-flex flex-column">
            <span class="reviewer-name">{{ currentUserFullName }}</span>
          </div>
        </div>

        <mat-form-field appearance="fill"
                        [hideRequiredMarker]="true"
                        [class]="reviewTextControl?.invalid ? 'scan-mat-form-field-invalid mat-form-field' : 'mat-form-field'">
          <mat-label class="d-flex align-items-center">
            <span class="mat-form-field-label">{{ 'rating.leaveReview' | translate }}</span>
            <span class="mat-form-field-label-optional">&nbsp;{{ 'rating.optional' | translate }}</span>
          </mat-label>
          <textarea
            matInput
            formControlName="reviewText"
            cdkTextareaAutosize
            [cdkAutosizeMinRows]="autosizeMinRows"
            [cdkAutosizeMaxRows]="5"
          ></textarea>
          @if (reviewTextControl?.invalid) {
            <mat-hint class="error-text">{{ 'rating.review_error_message' | translate }}</mat-hint>
          }
          <mat-hint align="end">{{ reviewTextControl?.value?.length || 0 }}/1000</mat-hint>
        </mat-form-field>
      </div>
    </form>
  </main>

</div>

<div class="position-fixed bottom-0 footer-container">
  <footer class="cards-by-qr-footer bg-white d-flex flex-column gap-2">
    <button class="footer--black-button"
            (click)="submitManageForm()"
            [disabled]="isSaveButtonDisabled">
      {{ isEditAction ? ('rating.delete_review_popup.saveChanges' | translate) : ('rating.delete_review_popup.save' | translate) }}
    </button>
    @if (isEditAction) {
      <button class="footer--white-button-with-border"
              (click)="deleteReview()">{{ 'rating.delete_review' | translate }}
      </button>
    }
    <button class="footer--white-button"
            (click)="onCancelClick()"
    >{{ 'rating.delete_review_popup.cancelButtonText' | translate }}
    </button>
  </footer>
</div>
